export enum StandardBagSsrs {
  CARRYON_BAG = 'CB10',
  CARRYON_BAG_15 = 'CB15',
  LIGHT_CHECKED_BAG = 'BA15',
  CLASSIC_CHECKED_BAG = 'BA23',
  HEAVY_CHECKED_BAG = 'BA32',
}

export enum OversizedBagSsrs {
  MUSICAL_INSTRUMENT = 'MUSC',
  SURFBOARD = 'SURF',
  BULKY_BAG = 'BULK',
  SPORTS_EQUIPMENT = 'SPEQ',
  BIKE = 'BIKE',
}

export enum StandardBagAncillarySsrs {
  CARRYON_BAG = 'CB10',
  CARRYON_BAG_15 = 'CB15',
  CLASSIC_CHECKED_BAG = 'BA23',
}

export enum OversizedBagAncillarySsrs {
  LIGHT_CHECKED_BAG = 'BA15',
  HEAVY_CHECKED_BAG = 'BA32',
  MUSICAL_INSTRUMENT = 'MUSC',
  SURFBOARD = 'SURF',
  BULKY_BAG = 'BULK',
  SPORTS_EQUIPMENT = 'SPEQ',
  BIKE = 'BIKE',
}

export enum NdcBagsSsrs {
  NDC_CARRYON_BAG = 'C010',
  NDC_CARRYON_BAG_15 = 'C015',
}